import React, { useState } from 'react';
import { TextField } from '@mui/material';

interface TimeInputProps {
    value: string;
    onChange: (value: string) => void;
    label: string;
    required?: boolean;
    helperText?: string;
}

const TimeInput: React.FC<TimeInputProps> = ({ value, onChange, label, required = false, helperText }) => {
    const [error, setError] = useState(false);

    const validateTime = (time: string) => {
        const timeRegex = /^([0-1][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/; // hh:mm:ss format
        return timeRegex.test(time);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let inputValue = e.target.value;

        // Remove invalid characters
        inputValue = inputValue.replace(/[^0-9:]/g, '');

        // Automatically add colons as the user types
        if (inputValue.length === 2 || inputValue.length === 5) {
            if (inputValue[inputValue.length - 1] !== ':') {
                inputValue += ':';
            }
        }

        // Restrict the length to hh:mm:ss
        if (inputValue.length <= 8) {
            setError(false);
            onChange(inputValue);

            // Validate completed inputs (when length is 8)
            if (inputValue.length === 8 && !validateTime(inputValue)) {
                setError(true);
            }
        }
    };

    const handleBlur = () => {
        // Validate when the field loses focus
        if (value && !validateTime(value)) {
            setError(true);
        } else {
            setError(false);
        }
    };

    return (
        <TextField
            label={label}
            type="text"
            variant="outlined"
            fullWidth
            required={required}
            value={value}
            onChange={handleInputChange}
            onBlur={handleBlur}
            error={error}
            helperText={error ? 'Неверный формат! Используйте чч:мм:сс, например 1мин 15с запишите так "00:01:15"' : helperText}
            placeholder="чч:мм:сс"
        />
    );
};

export default TimeInput;
